import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { setLenis } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeBand from "@/components/MarqueeBand";
import Vault from "@/components/Vault";
import Licensing from "@/components/Licensing";
import Producer from "@/components/Producer";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import DownloadsModal from "@/components/DownloadsModal";
import PaymentResult from "@/components/PaymentResult";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err) {
    console.error(err);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#050507] text-white flex items-center justify-center p-8">
          <div className="text-center max-w-md">
            <img src="/images/logo-vice.jpg" alt="DJ Miami" className="w-40 mx-auto mb-6" />
            <h1 className="font-display text-2xl mb-3 uppercase">Something skipped.</h1>
            <p className="text-white/60 mb-6">A part of the page hit a snag. Reload to get back to the music.</p>
            <button
              data-testid="error-reload-btn"
              onClick={() => window.location.reload()}
              className="bg-[#FF007F] px-6 py-3 uppercase tracking-widest text-sm font-bold hover:shadow-[0_0_32px_rgba(255,0,127,0.45)] transition-shadow"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = () => (
  <div className="bg-[#050507] text-white relative">
    <div className="grain" aria-hidden="true" />
    <Navbar />
    <main>
      <Hero />
      <MarqueeBand />
      <Vault />
      <Licensing />
      <Producer />
      <Contact />
    </main>
    <Footer />
    <DownloadsModal />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/payment/success" element={<PaymentResult status="success" />} />
          <Route path="/payment/cancel" element={<PaymentResult status="cancel" />} />
        </Routes>
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#111116", border: "1px solid rgba(255,255,255,0.12)", color: "#fff" } }} />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
